const brand = {
  blaze: {
    50: "rgba(255, 239, 229, 1)",
    100: "rgba(255, 217, 193, 1)",
    200: "rgba(255, 179, 129, 1)",
    300: "rgba(255, 154, 86, 1)",
    400: "rgba(255, 128, 43, 1)",
    500: "rgba(255, 102, 0, 1)",
    600: "rgba(215, 89, 27, 1)",
    700: "rgba(102, 41, 0, 1)",
    800: "rgba(153, 61, 0, 1)",
    900: "rgba(51, 20, 0, 1)",
    950: "rgba(50, 25, 11, 1)"
  },
  sand: {
    50: "rgba(250, 246, 235, 1)",
    100: "rgba(243, 230, 199, 1)",
    200: "rgba(237, 218, 170, 1)",
    300: "rgba(231, 205, 142, 1)",
    400: "rgba(202, 179, 124, 1)",
    500: "rgba(173, 154, 106, 1)",
    600: "rgba(144, 128, 89, 1)",
    700: "rgba(115, 102, 71, 1)",
    800: "rgba(86, 76, 53, 1)",
    900: "rgba(57, 51, 35, 1)",
    950: "rgba(28, 25, 17, 1)"
  },
  volt: {
    50: "rgba(253, 244, 224, 1)",
    100: "rgba(248, 230, 190, 1)",
    200: "rgba(245, 216, 150, 1)",
    300: "rgba(232, 196, 112, 1)",
    400: "rgba(224, 182, 84, 1)",
    500: "rgba(215, 170, 65, 1)",
    600: "rgba(196, 153, 53, 1)",
    700: "rgba(170, 129, 36, 1)",
    800: "rgba(140, 103, 16, 1)",
    900: "rgba(106, 74, 0, 1)"
  },
  forest: {
    50: "rgba(244, 245, 241, 1)",
    100: "rgba(224, 228, 215, 1)",
    200: "rgba(202, 207, 187, 1)",
    300: "rgba(173, 182, 149, 1)",
    400: "rgba(152, 163, 122, 1)",
    500: "rgba(131, 145, 95, 1)",
    600: "rgba(111, 126, 69, 1)",
    700: "rgba(90, 108, 42, 1)",
    800: "rgba(67, 81, 31, 1)",
    900: "rgba(45, 54, 21, 1)",
    950: "rgba(22, 27, 10, 1)"
  },
  black: {
    50: "rgba(247, 246, 246, 1)",
    100: "rgba(238, 237, 236, 1)",
    200: "rgba(221, 220, 218, 1)",
    300: "rgba(196, 195, 194, 1)",
    400: "rgba(155, 154, 151, 1)",
    500: "rgba(126, 125, 123, 1)",
    600: "rgba(90, 90, 88, 1)",
    700: "rgba(65, 64, 63, 1)",
    800: "rgba(47, 46, 44, 1)",
    900: "rgba(33, 32, 30, 1)",
    950: "rgba(19, 18, 16, 1)",
    white: "rgba(255, 255, 255, 1)"
  }
};
const functional = {
  green: {
    100: "rgba(222, 250, 233, 1)",
    200: "rgba(207, 249, 221, 1)",
    300: "rgba(166, 244, 197, 1)",
    400: "rgba(108, 233, 166, 1)",
    500: "rgba(50, 213, 131, 1)",
    600: "rgba(18, 183, 106, 1)",
    700: "rgba(3, 152, 85, 1)",
    800: "rgba(2, 122, 72, 1)",
    900: "rgba(5, 96, 58, 1)",
    950: "rgba(5, 79, 49, 1)"
  },
  red: {
    100: "rgba(255, 243, 241, 1)",
    200: "rgba(254, 228, 226, 1)",
    300: "rgba(254, 205, 202, 1)",
    400: "rgba(253, 162, 155, 1)",
    500: "rgba(249, 112, 102, 1)",
    600: "rgba(204, 60, 50, 1)",
    700: "rgba(217, 45, 32, 1)",
    800: "rgba(180, 35, 24, 1)",
    900: "rgba(145, 32, 24, 1)",
    950: "rgba(124, 19, 3, 1)"
  },
  yellow: {
    100: "rgba(255, 250, 235, 1)",
    200: "rgba(254, 240, 199, 1)",
    300: "rgba(254, 223, 137, 1)",
    400: "rgba(254, 200, 75, 1)",
    500: "rgba(253, 176, 34, 1)",
    600: "rgba(247, 144, 9, 1)",
    700: "rgba(220, 104, 3, 1)",
    800: "rgba(181, 71, 8, 1)",
    900: "rgba(147, 55, 13, 1)",
    950: "rgba(122, 46, 14, 1)"
  },
  blue: {
    100: "rgba(239, 248, 255, 1)",
    200: "rgba(209, 233, 255, 1)",
    300: "rgba(178, 221, 255, 1)",
    400: "rgba(132, 202, 255, 1)",
    500: "rgba(83, 177, 253, 1)",
    600: "rgba(46, 144, 250, 1)",
    700: "rgba(21, 112, 239, 1)",
    800: "rgba(23, 92, 211, 1)",
    900: "rgba(24, 73, 169, 1)",
    950: "rgba(25, 65, 133, 1)"
  },
  teal: {
    100: "rgba(195, 221, 215, 1)",
    200: "rgba(180, 236, 222, 1)",
    300: "rgba(144, 226, 207, 1)",
    400: "rgba(108, 217, 191, 1)",
    500: "rgba(72, 208, 175, 1)",
    600: "rgba(36, 198, 159, 1)",
    700: "rgba(0, 189, 144, 1)",
    800: "rgba(0, 142, 108, 1)",
    900: "rgba(0, 94, 72, 1)",
    950: "rgba(0, 47, 36, 1)"
  },
  coolGrey: {
    100: "rgba(247, 248, 249, 1)",
    200: "rgba(232, 236, 239, 1)",
    300: "rgba(218, 224, 227, 1)",
    400: "rgba(200, 208, 212, 1)",
    500: "rgba(176, 187, 193, 1)",
    600: "rgba(151, 165, 173, 1)",
    700: "rgba(127, 144, 153, 1)",
    800: "rgba(89, 101, 107, 1)",
    900: "rgba(60, 69, 74, 1)",
    950: "rgba(34, 40, 43, 1)"
  },
  warmGrey: {
    100: "rgba(246, 244, 239, 1)",
    200: "rgba(235, 230, 223, 1)",
    300: "rgba(212, 207, 197, 1)",
    400: "rgba(194, 188, 177, 1)",
    500: "rgba(161, 155, 141, 1)",
    600: "rgba(129, 123, 110, 1)",
    700: "rgba(98, 93, 82, 1)",
    800: "rgba(80, 74, 64, 1)",
    900: "rgba(66, 61, 51, 1)",
    950: "rgba(39, 36, 29, 1)"
  }
};
const tailwind = {
  slate: {
    50: "rgba(248, 250, 252, 1)",
    100: "rgba(241, 245, 249, 1)",
    200: "rgba(226, 232, 240, 1)",
    300: "rgba(203, 213, 225, 1)",
    400: "rgba(148, 163, 184, 1)",
    500: "rgba(100, 116, 139, 1)",
    600: "rgba(71, 85, 105, 1)",
    700: "rgba(51, 65, 85, 1)",
    800: "rgba(30, 41, 59, 1)",
    900: "rgba(15, 23, 42, 1)",
    950: "rgba(2, 6, 23, 1)"
  },
  gray: {
    50: "rgba(249, 250, 251, 1)",
    100: "rgba(243, 244, 246, 1)",
    200: "rgba(229, 231, 235, 1)",
    300: "rgba(209, 213, 219, 1)",
    400: "rgba(156, 163, 175, 1)",
    500: "rgba(107, 114, 128, 1)",
    600: "rgba(75, 85, 99, 1)",
    700: "rgba(55, 65, 81, 1)",
    800: "rgba(31, 41, 55, 1)",
    900: "rgba(17, 24, 39, 1)",
    950: "rgba(3, 7, 18, 1)"
  },
  zinc: {
    50: "rgba(250, 250, 250, 1)",
    100: "rgba(244, 244, 245, 1)",
    200: "rgba(228, 228, 231, 1)",
    300: "rgba(212, 212, 216, 1)",
    400: "rgba(161, 161, 170, 1)",
    500: "rgba(113, 113, 122, 1)",
    600: "rgba(82, 82, 91, 1)",
    700: "rgba(63, 63, 70, 1)",
    800: "rgba(39, 39, 42, 1)",
    900: "rgba(24, 24, 27, 1)",
    950: "rgba(9, 9, 11, 1)"
  },
  neutral: {
    50: "rgba(250, 250, 250, 1)",
    100: "rgba(245, 245, 245, 1)",
    200: "rgba(229, 229, 229, 1)",
    300: "rgba(212, 212, 212, 1)",
    400: "rgba(163, 163, 163, 1)",
    500: "rgba(115, 115, 115, 1)",
    600: "rgba(82, 82, 82, 1)",
    700: "rgba(64, 64, 64, 1)",
    800: "rgba(38, 38, 38, 1)",
    900: "rgba(23, 23, 23, 1)",
    950: "rgba(10, 10, 10, 1)"
  },
  stone: {
    50: "rgba(250, 250, 249, 1)",
    100: "rgba(245, 245, 244, 1)",
    200: "rgba(231, 229, 228, 1)",
    300: "rgba(214, 211, 209, 1)",
    400: "rgba(168, 162, 158, 1)",
    500: "rgba(120, 113, 108, 1)",
    600: "rgba(87, 83, 78, 1)",
    700: "rgba(68, 64, 60, 1)",
    800: "rgba(41, 37, 36, 1)",
    900: "rgba(28, 25, 23, 1)",
    950: "rgba(12, 10, 9, 1)"
  },
  red: {
    50: "rgba(254, 242, 242, 1)",
    100: "rgba(254, 226, 226, 1)",
    200: "rgba(254, 202, 202, 1)",
    300: "rgba(252, 165, 165, 1)",
    400: "rgba(248, 113, 113, 1)",
    500: "rgba(239, 68, 68, 1)",
    600: "rgba(220, 38, 38, 1)",
    700: "rgba(185, 28, 28, 1)",
    800: "rgba(153, 27, 27, 1)",
    900: "rgba(127, 29, 29, 1)",
    950: "rgba(69, 10, 10, 1)"
  },
  orange: {
    50: "rgba(255, 247, 237, 1)",
    100: "rgba(255, 237, 213, 1)",
    200: "rgba(254, 215, 170, 1)",
    300: "rgba(253, 186, 116, 1)",
    400: "rgba(251, 146, 60, 1)",
    500: "rgba(249, 115, 22, 1)",
    600: "rgba(234, 88, 12, 1)",
    700: "rgba(194, 65, 12, 1)",
    800: "rgba(154, 52, 18, 1)",
    900: "rgba(124, 45, 18, 1)",
    950: "rgba(67, 20, 7, 1)"
  },
  amber: {
    50: "rgba(255, 251, 235, 1)",
    100: "rgba(254, 243, 199, 1)",
    200: "rgba(253, 230, 138, 1)",
    300: "rgba(252, 211, 77, 1)",
    400: "rgba(251, 191, 36, 1)",
    500: "rgba(245, 158, 11, 1)",
    600: "rgba(217, 119, 6, 1)",
    700: "rgba(180, 83, 9, 1)",
    800: "rgba(146, 64, 14, 1)",
    900: "rgba(120, 53, 15, 1)",
    950: "rgba(69, 26, 3, 1)"
  },
  yellow: {
    50: "rgba(254, 252, 232, 1)",
    100: "rgba(254, 249, 195, 1)",
    200: "rgba(254, 240, 138, 1)",
    300: "rgba(253, 224, 71, 1)",
    400: "rgba(250, 204, 21, 1)",
    500: "rgba(234, 179, 8, 1)",
    600: "rgba(202, 138, 4, 1)",
    700: "rgba(161, 98, 7, 1)",
    800: "rgba(133, 77, 14, 1)",
    900: "rgba(113, 63, 18, 1)",
    950: "rgba(66, 32, 6, 1)"
  },
  lime: {
    50: "rgba(247, 254, 231, 1)",
    100: "rgba(236, 252, 203, 1)",
    200: "rgba(217, 249, 157, 1)",
    300: "rgba(190, 242, 100, 1)",
    400: "rgba(163, 230, 53, 1)",
    500: "rgba(132, 204, 22, 1)",
    600: "rgba(101, 163, 13, 1)",
    700: "rgba(77, 124, 15, 1)",
    800: "rgba(63, 98, 18, 1)",
    900: "rgba(54, 83, 20, 1)",
    950: "rgba(26, 46, 5, 1)"
  },
  green: {
    50: "rgba(240, 253, 244, 1)",
    100: "rgba(220, 252, 231, 1)",
    200: "rgba(187, 247, 208, 1)",
    300: "rgba(134, 239, 172, 1)",
    400: "rgba(74, 222, 128, 1)",
    500: "rgba(34, 197, 94, 1)",
    600: "rgba(22, 163, 74, 1)",
    700: "rgba(21, 128, 61, 1)",
    800: "rgba(22, 101, 52, 1)",
    900: "rgba(20, 83, 45, 1)",
    950: "rgba(5, 46, 22, 1)"
  },
  emerald: {
    50: "rgba(236, 253, 245, 1)",
    100: "rgba(209, 250, 229, 1)",
    200: "rgba(167, 243, 208, 1)",
    300: "rgba(110, 231, 183, 1)",
    400: "rgba(52, 211, 153, 1)",
    500: "rgba(16, 185, 129, 1)",
    600: "rgba(5, 150, 105, 1)",
    700: "rgba(4, 120, 87, 1)",
    800: "rgba(6, 95, 70, 1)",
    900: "rgba(6, 78, 59, 1)",
    950: "rgba(2, 44, 34, 1)"
  },
  teal: {
    50: "rgba(240, 253, 250, 1)",
    100: "rgba(204, 251, 241, 1)",
    200: "rgba(153, 246, 228, 1)",
    300: "rgba(94, 234, 212, 1)",
    400: "rgba(45, 212, 191, 1)",
    500: "rgba(20, 184, 166, 1)",
    600: "rgba(13, 148, 136, 1)",
    700: "rgba(15, 118, 110, 1)",
    800: "rgba(17, 94, 89, 1)",
    900: "rgba(19, 78, 74, 1)",
    950: "rgba(4, 47, 46, 1)"
  },
  cyan: {
    50: "rgba(236, 254, 255, 1)",
    100: "rgba(207, 250, 254, 1)",
    200: "rgba(165, 243, 252, 1)",
    300: "rgba(103, 232, 249, 1)",
    400: "rgba(34, 211, 238, 1)",
    500: "rgba(6, 182, 212, 1)",
    600: "rgba(8, 145, 178, 1)",
    700: "rgba(14, 116, 144, 1)",
    800: "rgba(21, 94, 117, 1)",
    900: "rgba(22, 78, 99, 1)",
    950: "rgba(8, 51, 68, 1)"
  },
  sky: {
    50: "rgba(240, 249, 255, 1)",
    100: "rgba(224, 242, 254, 1)",
    200: "rgba(186, 230, 253, 1)",
    300: "rgba(125, 211, 252, 1)",
    400: "rgba(56, 189, 248, 1)",
    500: "rgba(14, 165, 233, 1)",
    600: "rgba(2, 132, 199, 1)",
    700: "rgba(3, 105, 161, 1)",
    800: "rgba(7, 89, 133, 1)",
    900: "rgba(12, 74, 110, 1)",
    950: "rgba(8, 47, 73, 1)"
  },
  blue: {
    50: "rgba(239, 246, 255, 1)",
    100: "rgba(219, 234, 254, 1)",
    200: "rgba(191, 219, 254, 1)",
    300: "rgba(147, 197, 253, 1)",
    400: "rgba(96, 165, 250, 1)",
    500: "rgba(59, 130, 246, 1)",
    600: "rgba(37, 99, 235, 1)",
    700: "rgba(29, 78, 216, 1)",
    800: "rgba(30, 64, 175, 1)",
    900: "rgba(30, 58, 138, 1)",
    950: "rgba(23, 37, 84, 1)"
  },
  indigo: {
    50: "rgba(238, 242, 255, 1)",
    100: "rgba(224, 231, 255, 1)",
    200: "rgba(199, 210, 254, 1)",
    300: "rgba(165, 180, 252, 1)",
    400: "rgba(129, 140, 248, 1)",
    500: "rgba(99, 102, 241, 1)",
    600: "rgba(79, 70, 229, 1)",
    700: "rgba(67, 56, 202, 1)",
    800: "rgba(55, 48, 163, 1)",
    900: "rgba(49, 46, 129, 1)",
    950: "rgba(30, 27, 75, 1)"
  },
  violet: {
    50: "rgba(245, 243, 255, 1)",
    100: "rgba(237, 233, 254, 1)",
    200: "rgba(221, 214, 254, 1)",
    300: "rgba(196, 181, 253, 1)",
    400: "rgba(167, 139, 250, 1)",
    500: "rgba(139, 92, 246, 1)",
    600: "rgba(124, 58, 237, 1)",
    700: "rgba(109, 40, 217, 1)",
    800: "rgba(91, 33, 182, 1)",
    900: "rgba(76, 29, 149, 1)",
    950: "rgba(46, 16, 101, 1)"
  },
  purple: {
    50: "rgba(250, 245, 255, 1)",
    100: "rgba(243, 232, 255, 1)",
    200: "rgba(233, 213, 255, 1)",
    300: "rgba(216, 180, 254, 1)",
    400: "rgba(192, 132, 252, 1)",
    500: "rgba(168, 85, 247, 1)",
    600: "rgba(147, 51, 234, 1)",
    700: "rgba(126, 34, 206, 1)",
    800: "rgba(107, 33, 168, 1)",
    900: "rgba(88, 28, 135, 1)",
    950: "rgba(59, 7, 100, 1)"
  },
  fuchsia: {
    50: "rgba(253, 244, 255, 1)",
    100: "rgba(250, 232, 255, 1)",
    200: "rgba(245, 208, 254, 1)",
    300: "rgba(240, 171, 252, 1)",
    400: "rgba(232, 121, 249, 1)",
    500: "rgba(217, 70, 239, 1)",
    600: "rgba(192, 38, 211, 1)",
    700: "rgba(162, 28, 175, 1)",
    800: "rgba(134, 25, 143, 1)",
    900: "rgba(112, 26, 117, 1)",
    950: "rgba(74, 4, 78, 1)"
  },
  pink: {
    50: "rgba(253, 242, 248, 1)",
    100: "rgba(252, 231, 243, 1)",
    200: "rgba(251, 207, 232, 1)",
    300: "rgba(249, 168, 212, 1)",
    400: "rgba(244, 114, 182, 1)",
    500: "rgba(236, 72, 153, 1)",
    600: "rgba(219, 39, 119, 1)",
    700: "rgba(190, 24, 93, 1)",
    800: "rgba(157, 23, 77, 1)",
    900: "rgba(131, 24, 67, 1)",
    950: "rgba(80, 7, 36, 1)"
  },
  rose: {
    50: "rgba(255, 241, 242, 1)",
    100: "rgba(255, 228, 230, 1)",
    200: "rgba(254, 205, 211, 1)",
    300: "rgba(253, 164, 175, 1)",
    400: "rgba(251, 113, 133, 1)",
    500: "rgba(244, 63, 94, 1)",
    600: "rgba(225, 29, 72, 1)",
    700: "rgba(190, 18, 60, 1)",
    800: "rgba(159, 18, 57, 1)",
    900: "rgba(136, 19, 55, 1)",
    950: "rgba(76, 5, 25, 1)"
  }
};
const colors = {
  ...tailwind,
  ...functional,
  ...brand
};
export {
  brand,
  colors,
  functional,
  tailwind
};
